import HeadTitle from "./HeadTitle";
import NextImage from "../../NextImage";
import DateStamp from "../../DateStamp";
import { ArticleItem } from "styles/jss/News.styles";
import { truncateString } from "utils/helperFunction";

export default function ArticleItems(news) {
  const {
    id,
    date,
    attributes: { title, slug, thumbnail, short_description, datetime, time },
  } = news;

  return (
    <ArticleItem>
      <div className="imageWrapper">
        <NextImage
          layout={"responsive"}
          width={180}
          height={150}
          objectFit={"cover"}
          src={thumbnail.data?.attributes?.formats?.thumbnail?.url}
          alt={title}
          placeholder="blur"
        />
      </div>
      <div className="contentWrapper">
        <HeadTitle as={"h2"} url={`/media-center/news/${id}/${slug}`}>
          {truncateString(title, 300)}
        </HeadTitle>
        <p className="text">{truncateString(short_description, 135)}</p>
        {date && <DateStamp date={datetime} time={time} />}
      </div>
    </ArticleItem>
  );
}
